<template>
  <Loading v-if="isLoading" />
  <vs-tabs v-else position="left" class="tabs-shadow-none mt-2">
    <vs-tab icon-pack="feather" icon="icon-info" label="General info">
      <MeetingGeneral :meeting="meeting" @update:meeting="save" />
    </vs-tab>

    <vs-tab icon-pack="feather" icon="icon-file-text" label="Google Docs">
      <MeetingGoogleDocs :meeting="meeting" @update:meeting="save" />
    </vs-tab>

    <vs-tab icon-pack="feather" icon="icon-activity" label="Meeting steps">
      <MeetingSteps :meeting="meeting" @update:meeting="save" />
    </vs-tab>
  </vs-tabs>
</template>

<script>
import MeetingGeneral from "./MeetingGeneral.vue";
import MeetingGoogleDocs from "./MeetingGoogleDocs.vue";
import MeetingSteps from "./MeetingSteps.vue";
import _ from "lodash";

export default {
  components: {
    MeetingGeneral,
    MeetingGoogleDocs,
    MeetingSteps
  },
  data() {
    return {
      meeting: null,
      isLoading: true
    };
  },
  async created() {
    this.isLoading = true;
    const meetingId = this.$route.params.id;
    this.meeting = await this.$store.dispatch("meetings/getMeeting", meetingId);
    await this.$store.dispatch("getRoles");
    console.log("Working on meeting", this.meeting);
    this.isLoading = false;
  },
  methods: {
    async save() {
      try {
        this.$vs.loading();
        console.log("Saving meeting", this.meeting);
        await this.$store.dispatch("meetings/updateMeeting", {
          id: this.meeting.id,
          dto: {
            enabled: this.meeting.enabled,
            title: this.meeting.title,
            description: this.meeting.description,
            initialAttendeesIdamRoles: this.meeting.initialAttendeesIdamRoles,
            allowedVenueIds: this.meeting.allowedVenueIds,
            meetingSteps: this.meeting.meetingSteps,
            templateFileId: this.meeting.templateFileId || null,
            documentCopyMode: this.meeting.documentCopyMode || "NewCopyEveryMeeting",
            display: this.meeting.display
          }
        });
        this.$vs.notify({
          color: "green",
          title: "Updated",
          text: "Succesfully updated"
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Could not update",
          text: err
        });
      } finally {
        this.$vs.loading.close();
      }
    }
  }
};
</script>
